import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../api/auth';

interface User {
  id: number; company_id: number; branch_id: number | null;
  role_id: number; name: string; email: string; scope: string; is_active: boolean;
}
interface AuthContextType {
  user: User | null; token: string | null; companyId: number | null; branchId: number | null;
  login: (token: string, user: User, companyId: number, branchId: number | null) => void;
  logout: () => void; isAuthenticated: boolean;
}
const AuthContext = createContext<AuthContextType | null>(null);
export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [companyId, setCompanyId] = useState<number | null>(null);
  const [branchId, setBranchId] = useState<number | null>(null);
  useEffect(() => {
    const t = localStorage.getItem('token');
    const u = localStorage.getItem('user');
    const c = localStorage.getItem('company_id');
    const b = localStorage.getItem('branch_id');
    if (t && u) { setToken(t); setUser(JSON.parse(u)); setCompanyId(c ? Number(c) : null); setBranchId(b ? Number(b) : null); }
  }, []);
  const login = (token: string, user: User, companyId: number, branchId: number | null) => {
    localStorage.setItem('token', token); localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('company_id', String(companyId)); localStorage.setItem('branch_id', String(branchId ?? ''));
    setToken(token); setUser(user); setCompanyId(companyId); setBranchId(branchId);
  };
  const logout = async () => {
    try { await authApi.logout(); } catch {}
    localStorage.removeItem('token'); localStorage.removeItem('user');
    localStorage.removeItem('company_id'); localStorage.removeItem('branch_id');
    setToken(null); setUser(null); setCompanyId(null); setBranchId(null);
    window.location.href = '/login';
  };
  return <AuthContext.Provider value={{ user, token, companyId, branchId, login, logout, isAuthenticated: !!token }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
